module.exports = __webpack_public_path__ + "media/images/elena_gorbacheva-061ac1ceea7093992c6fee9b602fa865.jpg";